import { useQuery } from "@apollo/client";
import { PERSON_DETAILS_HEADER_QUERY } from "@/pages/people/[pgaId]/queries";

/**
 * Hook to check if a person exists and is accessible
 * Returns error state that can be used to conditionally render error UI
 */
export function usePersonExists(pgaId: string | undefined) {
  const { error, loading } = useQuery(PERSON_DETAILS_HEADER_QUERY, {
    variables: { pgaId },
    skip: !pgaId,
    errorPolicy: "all", // Don't throw, just return error
    fetchPolicy: "network-only", // Always fetch fresh data, don't use cache
    notifyOnNetworkStatusChange: true
  });

  return {
    personNotFound: !!error,
    loading
  };
}
